import { useEffect } from 'react';

// react-router-dom components
import { useLocation } from 'react-router-dom';

// prop-types is a library for typechecking of props.
import PropTypes from 'prop-types';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';

// Material Dashboard 2 PRO React context
import { useMaterialUIController, setLayout } from 'context';

function DashboardLayout({ children, isModal }) {
    const [controller, dispatch] = useMaterialUIController();
    const { miniSidenav } = controller;
    const { pathname } = useLocation();

    useEffect(() => {
        setLayout(dispatch, 'dashboard');
    }, [pathname]);

    if (isModal)
        return (
            <MDBox
                sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
                    p: 3,
                    position: 'relative',
                    [breakpoints.up('xl')]: {
                        marginLeft: 0,
                        transition: transitions.create(['margin-left', 'margin-right'], {
                            easing: transitions.easing.easeInOut,
                            duration: transitions.duration.standard,
                        }),
                    },
                })}
            >
                {children}
            </MDBox>
        );

    return (
        <MDBox
            sx={({ breakpoints, transitions, functions }) => ({
                p: 3,
                position: 'relative',
                [breakpoints.up('xl')]: {
                    marginLeft: miniSidenav ? functions.pxToRem(120) : functions.pxToRem(274),
                    transition: transitions.create(['margin-left', 'margin-right'], {
                        easing: transitions.easing.easeInOut,
                        duration: transitions.duration.standard,
                    }),
                },
            })}
        >
            {children}
        </MDBox>
    );
}

// Typechecking props for the DashboardLayout
// DashboardLayout.propTypes = {
//     children: PropTypes.node.isRequired,
// };

export default DashboardLayout;
